import { GetConsumerAuditLogsArgs } from "../actions/customerManagementActions";

interface AuditLogRequest {
  query: Record<string, string>;
  body: Record<string, any>;
}

export const buildAuditLogRequest = (args: GetConsumerAuditLogsArgs = {}): AuditLogRequest => {
  const query: Record<string, string> = {};
  const body: Record<string, any> = {};

  // uid stays as a query param
  if (args.uid) {
    query.uid = args.uid;
  }

  // Everything else goes into the POST body
  if (args.startDate) body.start_date = args.startDate;
  if (args.endDate) body.end_date = args.endDate;
  if (args.page) body.page = args.page;
  if (args.limit) body.limit = args.limit;
  if (args.filters) body.filters = args.filters;

  return { query, body };
};
